import React, { useState } from 'react';
import * as S from '../styles';
import Texts from '../../Texts';
import FileUpload from '../../../helper/FileUpload';
import uploadIcon from '/src/assets/images/application/folder-file-up.svg?url';
import ImageEditContainer from './ImageEditeContainer';
import axios from 'axios';

interface ApplicationStepFourProps {
  logo: string | null | File;
  /**
   * The logo on screen is one the publisher uploaded against an approved
   * listing that has not been reviewed yet, so the store still serves the
   * previous one. Marked rather than hidden: they need to see it arrived.
   */
  logoPending?: boolean;
  // `is_pending` is passed through to ImageEditContainer, which marks the
  // staged shots. Leaving it off this type silently dropped the flag.
  screenshots: { id: number; url: string; is_pending?: boolean }[];
  onLogoChange: (file: File | null) => void;
  onAddScreenshots: (files: File[]) => void;
  onRemoveScreenshot: (index: number) => void;
  onDeleteScreenshot: (id: number) => Promise<void>;
}

const ApplicationEditStepFour: React.FC<ApplicationStepFourProps> = ({
  logo,
  logoPending = false,
  screenshots,
  onLogoChange,
  onAddScreenshots,
  onRemoveScreenshot,
  onDeleteScreenshot,
}) => {
  const [screenshotFiles, setScreenshotFiles] = useState<File[]>([]);
  const [logoFile, setLogoFile] = useState<File | null>(null);

  const handleLogoChange = (files: File[]) => {
    const file = files.length > 0 ? files[0] : null; // Take the first file or null if no files
    setLogoFile(file);
    onLogoChange(file);
    console.log(
      'Logo file:',
      file ? { name: file.name, type: file.type, size: file.size } : null,
    );
  };

  const handleAddScreenshots = (files: File[]) => {
    setScreenshotFiles(files);
    console.log(
      'Files received in handleAddScreenshots:',
      files.map((f) => ({
        name: f.name,
        type: f.type,
        size: f.size,
      })),
    );
    onAddScreenshots(files);
  };

  const handleRemoveScreenshot = (index: number) => {
    setScreenshotFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    onRemoveScreenshot(index);
  };

  // const uploadToServer = async () => {
  //   const formData = new FormData();

  //   if (logoFile) {
  //     formData.append('logo', logoFile);
  //   }
  //   screenshotFiles.forEach((file, index) => {
  //     formData.append(`screen_shots[${index}]`, file);
  //   });

  //   try {
  //     const response = await axios.post('YOUR_SERVER_ENDPOINT', formData, {
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //       },
  //     });
  //     console.log('Server response:', response.data);
  //     return response.data;
  //   } catch (error) {
  //     console.error('Error uploading files:', error);
  //     throw error;
  //   }
  // };

  return (
    <S.Container fluid style={{ marginBottom: '20px' }}>
      <S.Label>{Texts.applicationStepFour.lableShort}</S.Label>
      <S.IconBox>
        <S.LabelInit>
          <S.Label>{Texts.applicationStepFour.fomatImage} |</S.Label>
          <S.Label>{Texts.applicationStepFour.sizeImage}</S.Label>
        </S.LabelInit>
        <div style={{ textAlign: 'center' }}>
          <img
            src={typeof logo === 'string' ? logo : ''}
            alt="Logo"
            style={{
              width: '50px',
              height: '50px',
              objectFit: 'contain',
              ...(logoPending
                ? { outline: '2px solid #F0AD4E', outlineOffset: '1px' }
                : {}),
            }}
          />
          {logoPending && (
            <div
              style={{
                marginTop: '6px',
                backgroundColor: '#FEF9C3',
                color: '#A16207',
                borderRadius: '4px',
                padding: '2px 6px',
                fontSize: '10px',
                fontFamily: 'IRANYekanXFaNum',
                whiteSpace: 'nowrap',
              }}
            >
              در انتظار بررسی
            </div>
          )}
        </div>
        <FileUpload
          height="48px"
          width="300px"
          compactView={true}
          showFileInfo={false}
          direction="rtl"
          flexDirection="row"
          onFilesSelected={handleLogoChange}
          imageSrc={uploadIcon}
          backgroundColor="#F0F0F0"
          uploadText={Texts.applicationStepFour.uploadIcon}
          acceptedFileTypes={['.png']}
        />
      </S.IconBox>
      <S.DividerIcon />
      <S.LabelInit>
        <S.Label>{Texts.applicationStepFour.lableDescriptionFa}</S.Label>
      </S.LabelInit>
      <S.ImageBox>
        <ImageEditContainer
          onImageUpload={handleAddScreenshots}
          onRemoveImage={handleRemoveScreenshot}
          existingImages={screenshots}
          onDeleteExisting={onDeleteScreenshot}
        />
      </S.ImageBox>
      {/* <button onClick={uploadToServer}>Upload to Server</button> */}
    </S.Container>
  );
};

export default ApplicationEditStepFour;
